import ModalActivateCoachAccount from './ModalActivateCoachAccount';

export default ModalActivateCoachAccount;
